import { Component, computed, DestroyRef, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { ServiceNotificationsCardsService } from '../../service-notifications-cards.service';
import { Router } from '@angular/router';
import { FirebaseService } from '@brightside-web/desktop/data-access/shared';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { interval } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ServiceNotificationIcon,
  ServiceNotificationItem
} from '@brightside-web/desktop/feature/service-notifications';
import { getRouteForKey } from '@brightside-web/desktop/data-access/core-services';
import { UrgentNotificationCardComponent } from '../urgent-notification-card/urgent-notification-card.component';

@Component({
    selector: 'brightside-web-card-carousel',
    imports: [CommonModule, BrightsideUiModule, UrgentNotificationCardComponent],
    templateUrl: './urgent-card-carousel.component.html',
    styleUrl: './urgent-card-carousel.component.scss',
    animations: [
        trigger('slide', [
            transition(':enter', [
                style({ transform: '{{enterTransform}}', opacity: 0 }),
                animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
            ], { params: { enterTransform: 'translateX(100%)' } }),
            transition(':leave', [animate('400ms ease-out', style({ transform: '{{leaveTransform}}', opacity: 0 }))], {
                params: { leaveTransform: 'translateX(-100%)' },
            }),
        ]),
    ]
})
export class UrgentCardCarouselComponent {
  currentIndex = 0;
  animationState: any = { value: '', params: { enterTransform: 'translateX(100%)', leaveTransform: 'translateX(-100%)' } };

  urgentNotificationsArray = computed(() => {
    const notifications = this._serviceNotificationsCardsService.urgentNotifications();
    if (notifications) {
      return notifications;
    }
    return [];
  });

  protected _serviceNotificationsCardsService = inject(ServiceNotificationsCardsService);
  private _translateSvc = inject(TranslateService);

  private _router = inject(Router);
  private _analytics = inject(FirebaseService);
  private _paused: boolean;
  private readonly _destroyRef = inject(DestroyRef);

  constructor() {
    interval(6000)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        const urgentNotificationsArray = this.urgentNotificationsArray();
        if (!this._paused && urgentNotificationsArray.length > 1) {
          queueMicrotask(() => this.next());
        }
      });
  }

  next() {
    const urgentNotificationsArray = this.urgentNotificationsArray();
    this.animationState = 'left';
    this.currentIndex = (this.currentIndex + 1) % urgentNotificationsArray.length;
  }

  prev() {
    const urgentNotificationsArray = this.urgentNotificationsArray();
    this.animationState = 'right';
    this.currentIndex = (this.currentIndex - 1 + urgentNotificationsArray.length) % urgentNotificationsArray.length;
  }

  goTo(index: number) {
    if (index > this.currentIndex) {
      this.animationState = 'left';
    } else if (index < this.currentIndex) {
      this.animationState = 'right';
    }
    this.currentIndex = index;
  }

  resetAnimationState() {
    this.animationState = '';
  }

  pauseCarousel() {
    this._paused = true;
  }

  resumeCarousel() {
    this._paused = false;
  }
}
